import useChartOptions from '@/features/_shared/chart/hooks/options/useChartOptions';
import useForwardCurveOptions from '@/features/_shared/chart/hooks/options/useForwardCurveOptions';
import { useForwardCurveChartSeries } from '@/features/charts';
import type { TemplateChartSeries } from '@/shared/types/charts';

import AuthenticatedChart from './AuthenticatedChart';

const AuthenticatedFwdCurveChart = ({
  templateChartSeries
}: {
  templateChartSeries: TemplateChartSeries[];
}) => {
  const { loading, error, chartSeries } = useForwardCurveChartSeries(templateChartSeries);
  const { createOptions } = useForwardCurveOptions(14);
  const { options: chartOptions } = useChartOptions(chartSeries, createOptions);
  return (
    <AuthenticatedChart
      chartOptions={chartOptions}
      chartSeries={chartSeries}
      chartType='forwardSimple'
      error={error}
      loading={loading}
    />
  );
};

export default AuthenticatedFwdCurveChart;
